/* Redux Toolkit */
import { createAsyncThunk } from "@reduxjs/toolkit";

/* Axios */
import axiosInterceptor from "src/utils/helper/axios-interceptor";

/* Utils */
import { ClientError } from "src/utils/status-handling/ClientError";

/* Interfaces */
import { ProviderProps } from "src/shared/interfaces/common/Provider";

export const providerInfo = createAsyncThunk<
  ProviderProps,
  void,
  { rejectValue: ClientError }
>("auth/providerInfo", async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInterceptor.get(
      "/provider_info"
    );

    return {
      google: {
        clientId: response.data.client_id,
        redirectUri: response.data.redirect_uri,
      },
    };
  } catch (error) {
    return rejectWithValue(ClientError.internal());
  }
});
